module.exports = __webpack_public_path__ + "img/halloween.85308fd8.jpg";